"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var browserUniversal = require('./browser');
__export(require('./browser'));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = browserUniversal;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-universal/browser/index.js
// module id = 27
// module chunks = 0